export enum LearningMode {
    Online = "Online",
    InPerson = "InPerson"
}

export enum LearningRequestStatus {
    Pending = "Pending",
    Contacted = "Contacted",
    MeetingScheduled = "MeetingScheduled",
    BatchAssigned = "BatchAssigned",
    Completed = "Completed"
}

export interface GroupLearningDashboardDto {
    hasSubmitted: boolean;

    learningMode?: LearningMode;

    country?: string;

    state?: string;

    district?: string;

    area?: string;

    memberCount: number;

    coordinatorId?: string;

    coordinatorName?: string;

    status?: LearningRequestStatus;

    canUpdate: boolean;
}

export interface CreateGroupLearningLocationDto {
    groupId: string;

    learningMode: LearningMode;

    country: string;

    state?: string;

    district?: string;

    area?: string;
}

export interface UpdateGroupLearningLocationDto
    extends CreateGroupLearningLocationDto {
}

export interface CoordinatorLearningLocationDto {

    userId: string;

    userName: string;

    email: string;

    phoneNumber: string;

    learningMode: LearningMode;

    country: string;

    state?: string;

    district?: string;

    area?: string;

    status: LearningRequestStatus;

    statusUpdatedAt?: string;

    statusUpdatedByUserId?: string;

    statusUpdatedByName?: string;
groupLearningLocationId:string;
    createdAt: string;

}